<div class="flex" (click)="onSort()">
    <span>{{ label }}</span>
    <div class="flex flex-col ml-2">
        <ng-container *ngFor="let datum of data">
            <span class="arrow {{ datum.type }}" [ngClass]="{'active': datum.value}"></span>
        </ng-container>
    </div>
</div>